/**
 * Check if Int32 value is zero
 *
 * @param {import('./Int32Type.js').BrandedInt32} value - Value
 * @returns {boolean} True if zero
 */
export function isZero(value) {
	return value === 0;
}
